<template>
    <div :data-component="$options.name">
        <section class="bg-color-signatur-immo-50 rounded-10 p-16 my-40 flex flex-wrap screen-m:flex-nowrap">
            <div class="flex grow screen-m:mr-16">
                <ms-placeholder-map class="w-100 h-100 mr-16 shrink-0" />
                <div class="flex-wrap">
                    <ms-headline type="h3">Standort</ms-headline>
                    <div class="flex gap-8 self-start mt-16 mb-8">
                        <ms-locator class="w-24 h-24 shrink-0" />
                        <div class="self-center break-all screen-m:break-keep text-text-l">
                            {{ address }}
                        </div>
                        <template v-if="isAddressHidden">
                            <cs-tooltip
                                v-if="isScreenM"
                                class="text-dustygray hover:text-black"
                                :position="'right'"
                                :showOnHover="true"
                            >
                                <template #trigger>
                                    <MsInformationCircle
                                        class="w-24 h-24 inline-block transition-colors duration-300 self-end"
                                    />
                                </template>
                                <span class="text-black">{{ tooltipText }}</span>
                            </cs-tooltip>
                            <ms-information-circle
                                v-if="!isScreenM"
                                class="w-24 h-24 text-dustygray self-end shrink-0"
                                @click="updateVisible"
                            />
                            <cs-tooltip-modal
                                v-if="!isScreenM"
                                class="px-16 self-center"
                                :visible="isTooltipModalOpen"
                                @update:visible="updateVisible"
                            >
                                <span class="mr-40">{{ tooltipText }}</span>
                            </cs-tooltip-modal>
                        </template>
                    </div>
                    <cs-copy-text-link
                        v-if="relocationLink"
                        :href="relocationLink.href"
                        :target="relocationLink.target"
                        class="break-all screen-m:break-keep"
                        @click="trackClickRelocation"
                        >{{ relocationLink.text }}</cs-copy-text-link
                    >
                </div>
            </div>
            <cs-secondary-button
                :isSmall="true"
                :isCentered="true"
                class="w-full screen-m:w-auto mt-16 shrink-0 screen-m:self-end"
                @click="openMap"
                >Karte ansehen</cs-secondary-button
            >
        </section>
        <cs-modal
            class="z-debug relative"
            :visible="showMapModal"
            :isFullscreen="true"
            :headerText="'Standort'"
            @update:visible="closeModal"
        >
            <div class="flex flex-col h-full screen-l:flex-row">
                <MsGoogleMaps
                    :apiKey="apiKey"
                    :locationCoordinates="locationCoordinates"
                    class="h-auto w-full grow shrink-0 mb-24 overflow-hidden relative rounded-10 screen-l:h-full screen-l:w-3/4 screen-l:grow-0"
                />
                <div class="flex flex-col screen-l:p-24">
                    <span class="text-h2 font-bold-headline mb-16 screen-l:mb-24">Adresse</span>
                    <div class="flex gap-8">
                        <ms-locator class="w-24 h-24 shrink-0" />
                        <div class="break-all text-text-l screen-m:break-keep">
                            {{ address }}
                        </div>
                    </div>
                    <div
                        v-if="isAddressHidden"
                        class="mt-8 screen-l:mt-16"
                    >
                        Die vollständige Adresse erhältst du von den Anbietenden.
                    </div>
                </div>
            </div>
        </cs-modal>
    </div>
</template>
<script lang="ts" src="./MsMap.ts" />
